/*
 * Project: bellcloud
 * File: apps/frontend/src/components/common/Resizer.tsx
 * Author: SWAN
 * Created: 2025-03-09
 * Description: 드래그 가능한 리사이저 컴포넌트
 */

import React, { useState } from 'react';
import { useTheme } from '@/theme';

interface ResizerProps {
  /** 리사이저 방향 */
  direction: 'horizontal' | 'vertical';
  /** 마우스 다운 이벤트 핸들러 */
  onMouseDown: (e: React.MouseEvent) => void;
  /** 드래그 중인지 여부 */
  isDragging?: boolean;
}

/**
 * 드래그 가능한 리사이저 컴포넌트
 */
export const Resizer: React.FC<ResizerProps> = ({ direction, onMouseDown, isDragging = false }) => {
  const { theme } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  const isHorizontal = direction === 'horizontal';
  const isActive = isDragging || isHovered;

  return (
    <div
      onMouseDown={onMouseDown}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        cursor: isHorizontal ? 'row-resize' : 'col-resize',
        position: 'relative',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: isHorizontal ? 'stretch' : 'center',
      }}
    >
      {/* 실제 핸들 */}
      <div
        style={{
          margin: `${theme.spacing[1]}px`,
          width: isHorizontal ? '36px' : '4px',
          height: isHorizontal ? '4px' : '36px',
          backgroundColor: isActive
            ? theme.colors.control.splitBar.select
            : theme.colors.control.splitBar.default,
          transition: 'background-color 0.2s',
          borderRadius: `${theme.borderRadius.full}px`,
        }}
      />
    </div>
  );
};
